import CloseIcon from '@mui/icons-material/Close';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import {Box, Button, Divider, IconButton, Tooltip} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useState,
} from 'react';

import BeltExport from '../../belt-node/BeltExport';
import BeltExportExcel from '../../belt-node/BeltExportExcel';
import BeltImport from '../../belt-node/BeltImport';
import ExportPdfButton from '../../common/ExportPdfButton';
import ModalFixed from '../../common/ModalFixed';
import {BeltMonitoringReportData} from '../ConnectView/BeltMonitoringReport';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  component?: T;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
  value?: BeltMonitoringReportData;
  onSubmitted?: () => void;
}

const BeltNodeImportExportButton = <T extends ComponentType>({
  component,
  componentProps,
  children,
  value,
  onSubmitted
}: Props<T>) => {
  const Component = component ?? Button;
  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      <Tooltip title="Export">
        <Component {...componentProps} onClick={() => setIsOpened(true)}>
          {children}
        </Component>
      </Tooltip>

      {isOpened ? (
        <ModalFixed open={isOpened} onClose={() => setIsOpened(false)}>
          <Box
            display="flex"
            flexDirection="column"
            position="relative"
            gap={3}
            p={3}
          >
            <Box display="flex" justifyContent="space-between">
              <Box display="flex" alignItems="center" width="100%" gap={1.5}>
                <ImportExportIcon sx={{color: 'primary.main'}} />
                <Box fontSize={24}>Export BeltNodes</Box>
              </Box>
              <IconButton onClick={() => setIsOpened(false)}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              position="relative"
              gap={3}
            >
              <Divider>Export</Divider>
              <BeltExport />
              <BeltExportExcel value={value} />
              <ExportPdfButton
                endpoint="/belt"
                defaultFilename="belt_list.pdf"
                params={value?.params}
                exportFields={value?.exportFields}
              />
              <Divider>Import</Divider>
              <BeltImport onSubmitted={onSubmitted} />
            </Box>
          </Box>
        </ModalFixed>
      ) : null}
    </>
  );
};

export default BeltNodeImportExportButton;
